import {useMutation} from '@apollo/client';
import {IRegisterForm} from 'packages/common-types/base-types';
import {
  CreateUserData,
  CreateUserVars,
} from 'packages/common-types/mutation-types';
import {CREATE_USER} from 'packages/graphql/v2/mutations';
import {GET_USERS} from 'packages/graphql/v2/queries';
import {useCallback, useState} from 'react';
import {signInUser} from 'services/firebase-service';
import Swal from 'sweetalert2';

type UseRegisterValues = {
  loading: boolean;
  onSubmit: (formData: IRegisterForm) => Promise<void>;
};

/**
 * @param {Boolean=} signIn  Determine if sign the user once created or not
 */
const useRegister = (signIn = true): UseRegisterValues => {
  const [loading, setLoading] = useState(false);
  const [createUser] = useMutation<CreateUserData, CreateUserVars>(CREATE_USER);

  const onSubmit = useCallback(
    async (formData: IRegisterForm) => {
      const {country, state, city, password, ...rest} = formData;
      setLoading(true);
      try {
        const input = {
          ...rest,
          password,
          address: {
            country,
            state,
            city,
          },
        };
        const createdUser = await createUser({
          variables: {
            input,
          },
          refetchQueries: !signIn // Don't update if we are creating the user from the admin panel
            ? [
                {
                  query: GET_USERS,
                },
              ]
            : [],
        });

        // Sign the user just after it's creation.
        if (createdUser.data && signIn) {
          await signInUser({emailInput: rest.email, passwordInput: password});
        }
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: 'Error',
          text: 'Ocurrio un error al crear el usuario',
          icon: 'error',
        });
      } finally {
        setLoading(false);
      }
    },
    [createUser, signIn]
  );

  return {loading, onSubmit};
};

export default useRegister;
